import { RefreshCwIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Version Update Banner
 *
 * Shows a non-intrusive banner when a new version of the app is available.
 * - Automatically disappears after refresh (user gets latest version)
 * - Only shows in production when version differs from deployed version
 * - Skipped in development mode
 */
export function VersionUpdateBanner() {
  const { hasUpdate, refresh } = useVersionCheck();

  if (!hasUpdate) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:bottom-4 sm:w-auto z-50">
      <div className="bg-background border border-border shadow-lg rounded-lg p-4 sm:max-w-md">
        <div className="flex items-center gap-3">
          {/* Icon */}
          <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
            <RefreshCwIcon className="h-4 w-4 text-primary" />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold">New version available</h4>
            <p className="text-xs text-muted-foreground mt-0.5">
              A new version of the application has been deployed. Refresh to get the latest
              features.
            </p>
          </div>

          {/* Refresh Button */}
          <Button size="sm" onClick={refresh} className="shrink-0 h-8">
            <RefreshCwIcon className="h-3 w-3 mr-1" />
            Refresh
          </Button>
        </div>
      </div>
    </div>
  );
}
